import {
  ButtonGroupPrimary,
  ButtonGroupWrapper,
  Card,
  FilledButton,
  Label,
  List,
  ListItem,
  Modal,
  ModalHeading,
  OutlinedButton,
  TextButton,
} from "@sainsburys-tech/luna-react";
import { PropTypes } from "prop-types";
import React, { Component } from "react";

const { ErrorCircle } = require("@sainsburys-tech/luna-icons");

class AddGondolaModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      gondolas: 1,
      rangeItems: [-1],
      disableAddBtn: true,
      disableSaveBtn: true,
      chosenGondola: 0,
      chosenBay: 0,
    };
    this.addAnotherGondola = this.addAnotherGondola.bind(this);
    this.removeGondola = this.removeGondola.bind(this);
    this.disableAddButton = this.disableAddButton.bind(this);
    this.addGondolaToRange = this.addGondolaToRange.bind(this);
    this.numberOfBays = 7;
    this.maxNumOfGondolas = 4;
  }

  componentDidUpdate(newProps) {
    if (newProps.isOpen !== this.props.isOpen && this.props.isOpen === true) {
      this.setState({
        rangeItems: [-1],
        gondolas: 1,
        disableAddBtn: true,
        disableSaveBtn: true,
      });
    }
  }

  findEmptyGondola(gondola) {
    return gondola < 0;
  }

  disableAddButton() {
    var emptyGondola = this.state.rangeItems.find(this.findEmptyGondola);
    if (
      this.state.rangeItems.length ===
        this.maxNumOfGondolas - this.props.rangeSize ||
      emptyGondola
    ) {
      if (emptyGondola === undefined) {
        this.setState({ disableSaveBtn: false });
      }
      this.setState({ disableAddBtn: true });

      this.getClassName(this.state.chosenGondola, this.state.chosenBay);
      return;
    } else {
      this.setState({ disableAddBtn: false, disableSaveBtn: false });
    }
  }

  addAnotherGondola() {
    const state = this.state;
    const newValue = state.gondolas + 1;
    var range = state.rangeItems.concat(-1);
    this.setState({
      gondolas: newValue,
      rangeItems: range,
      disableAddBtn: true,
      disableSaveBtn: true,
    });
  }

  removeGondola(gondola) {
    const state = this.state;
    const newValue = this.state.gondolas - 1;
    state.rangeItems.splice(gondola, 1);
    this.setState({ gondolas: newValue });
    this.disableAddButton();
  }

  getClassName(gondola, bay) {
    if (bay <= this.state.rangeItems[gondola]) {
      return "fillButton";
    } else {
      return "noFillButton";
    }
  }

  gondolaSizeClick(gondola, bay) {
    const state = this.state;
    const rangeArray = state.rangeItems;
    rangeArray[gondola] = bay;
    this.setState({
      rangeItems: rangeArray,
      chosenBay: bay,
      chosenGondola: gondola,
    });
    this.disableAddButton();
  }

  addGondolaToRange(e) {
    const { rangeItems } = this.state;
    const { rangeId } = this.props;
    let newGondolas = [];
    rangeItems.forEach(function (item) {
      newGondolas.push({
        projectGradeRangeId: rangeId,
        bayCount: item + 1,
      });
    });
    if (this.props.onHandleAddGondolaSaveButton(newGondolas) === true) {
      this.props.onModalClose(e, rangeItems.length);
    }
  }

  renderGondolas = () => {
    let rangeArray = Array(this.state.gondolas);
    let gondolaArray = Array(this.numberOfBays);
    if (this.state.gondolas) {
      return (
        <List type="bare" spaced>
          {rangeArray.fill(0).map((_, gondolaIndex) => (
            <ListItem key={gondolaIndex} className={"gondola-list"}>
              <List type="matrix">
                <ListItem
                  className={
                    gondolaIndex < 9
                      ? "gondola-label-lt10"
                      : "gondola-label-mt10"
                  }
                >
                  <Label htmlFor="">
                    Gondola {gondolaIndex + this.props.rangeSize + 1}
                  </Label>
                </ListItem>
                {gondolaArray.fill(0).map((_, bayIndex) => (
                  <ListItem key={bayIndex} className={"bay-buttons"}>
                    <OutlinedButton
                      color="dark"
                      data-testid={`add-gondola-button-${bayIndex + 1}`}
                      className={this.getClassName(gondolaIndex, bayIndex)}
                      onClick={(e) =>
                        this.gondolaSizeClick(gondolaIndex, bayIndex)
                      }
                    >
                      {bayIndex + 1}
                    </OutlinedButton>
                  </ListItem>
                ))}
                {gondolaIndex >= 1 && (
                  <ListItem>
                    <TextButton
                      color="dark"
                      tabIndex={"0"}
                      className={"remove-link"}
                      onClick={() => this.removeGondola(gondolaIndex)}
                    >
                      Remove
                    </TextButton>
                  </ListItem>
                )}
              </List>
            </ListItem>
          ))}
        </List>
      );
    }
  };

  render = () => {
    return (
      <Modal
        data-testid="gondola-modal"
        restrictClose
        open={this.props.isOpen}
        className={"add-gondola-modal-body"}
      >
        <Card className={"modal-gondola-body"}>
          <ModalHeading className={"modalheading"}>
            {"Add gondola"}
          </ModalHeading>
          <p
            data-testid="gondola-description"
            className={"bayConfig-description"}
          >
            Any new gondolas will be added to the bottom of the range.
          </p>
          <div className={"gondola-configuration"}>{this.renderGondolas()}</div>
          <div className={"add-gondola-container"}>
            <OutlinedButton
              color="dark"
              data-testid="add-another-gondola-button"
              className={"add-gondola-button"}
              onClick={() => this.addAnotherGondola()}
              disabled={this.state.disableAddBtn}
            >
              <p className="add-another-gondola-text">Add another gondola</p>
            </OutlinedButton>
            {this.state.gondolas ===
              this.maxNumOfGondolas - this.props.rangeSize && (
              <div className="error-circle-container">
                <ErrorCircle
                  data-testid="error-circle"
                  className={"error-circle"}
                />{" "}
                <p className={"error-circle-description"}>
                  {" "}
                  The maximum number of Gondolas has been reached
                </p>
              </div>
            )}
          </div>
          <ButtonGroupWrapper actionBar className={"saveCancelButtonWrapper"}>
            <ButtonGroupPrimary>
              <OutlinedButton
                color="dark"
                data-testid="cancel-button"
                className={"cancel-button"}
                onClick={(e) =>
                  this.props.onModalClose(e, this.state.rangeItems.length)
                }
              >
                Cancel
              </OutlinedButton>
              <FilledButton
                data-testid="save-button"
                className={"save-button"}
                onClick={(e) => this.addGondolaToRange(e)}
                disabled={this.state.disableSaveBtn}
              >
                Add to range
              </FilledButton>
            </ButtonGroupPrimary>
          </ButtonGroupWrapper>
        </Card>
      </Modal>
    );
  };
}

AddGondolaModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
  rangeSize: PropTypes.number,
  onHandleAddGondolaSaveButton: PropTypes.func,
  rangeId: PropTypes.number,
};

export default AddGondolaModal;
